import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createImageMockSource } from '@/mocks/create-image-mock-source';
import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { GiftBusinessDetailResponse } from '@/repositories/generated';

const response: GiftBusinessDetailResponse = {
  giftBusinessId: '001',
  giftBusinessName: '青森市プレミアム付電子商品券',
  remarks: '（運営者メモ）第1期〜第3期を予定。第2期は10月頃の販売開始を想定。',
  giftBusinessBasicInfo: {
    walletServiceId: 'WS1',
    giftIssuerId: 'ISS001',
    giftIssuerName: '〇〇市商品券事業協会',
    createdAt: '2025-05-12T17:41:00+09:00',
    updatedAt: '2025-05-12T17:41:00+09:00',
    giftBusinessImagePath: createImageMockSource('商品券事業', { width: 750, height: 220 }),
    giftBusinessDescription: 'あ'.repeat(2000),
    customField1: 'い'.repeat(2000),
    customField2: 'う'.repeat(2000),
    customField3: 'え'.repeat(2000),
    customField4: 'お'.repeat(2000),
    customField5: 'か'.repeat(2000),
  },
};

export const giftBusinessDetail = http.get(
  createMockEndpoint('/gift_business/:id'),
  async () => {
    await delay(500);
    return HttpResponse.json(response, { status: 200 });
  },
);
